import React, {Fragment, useContext, useEffect, useState} from "react";
import {Form, FormGroup} from "reactstrap";
import {useForm} from "react-hook-form";
import {Btn} from "../../../../../AbstractElements";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import type {Wallet} from "../../Types/WalletTypes";

interface WalletFormValues {
    current_balance: number;
}

interface WalletFormProps {
    wallet?: Wallet | null;
    callBack?: (wallet: Wallet) => void;
}

const WalletForm = ({wallet, callBack}: WalletFormProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register,
        handleSubmit,
        setError,
        clearErrors,
        formState: {errors},
        setValue,
    } = useForm<WalletFormValues>();

    useEffect(() => {
        if (wallet) {
            setValue('current_balance', Number(wallet.current_balance ?? 0));
        }
    }, [wallet, setValue]);

    const onSubmit = (data: WalletFormValues) => {
        if (!wallet?.id) return;
        clearErrors();
        setLoaderVisibility(true);
        axiosConfig
            .put(`${getApplicationRoute('wallet')}/${wallet.id}`, data)
            .then((response: { data: { data: Wallet; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    };

    return (
        <Fragment>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Loader visibility={loaderVisibility}/>
                <TextInput name={'current_balance'} type={'number'} label={'Current Balance'} register={register}
                           errors={errors} placeholder={'0.00'} options={{required: true}}/>
                <FormGroup>
                    <Btn attrBtn={{
                        className: 'd-block w-100 mt-4',
                        color: 'primary',
                        type: 'submit'
                    }}>Update</Btn>
                </FormGroup>
            </Form>
        </Fragment>
    );
};

export default WalletForm;

